import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-facebook-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-facebook-svg-icon.component.html',
  styleUrl: './ln-facebook-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnFacebookSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#372121';
}
